import api from './api';

/**
 * CRUD client for saved question papers (main SohozKaj API).
 * The shared `api` instance already unwraps the response to the
 * `{ success, message, data, pagination }` envelope.
 */
const questionPaperService = {
    list: (params = {}) => api.get('/api/question-papers', { params }),

    get: (id) => api.get(`/api/question-papers/${id}`),

    create: (data) => api.post('/api/question-papers', data),

    update: (id, data) => api.put(`/api/question-papers/${id}`, data),

    remove: (id) => api.delete(`/api/question-papers/${id}`),

    // Like/dislike a saved paper. `reason` (predefined key) + `note` accompany a dislike.
    submitFeedback: (id, feedback, reason = null, note = null) => {
        const body = { feedback };
        if (reason) body.reason = reason;
        if (note) body.note = note;
        return api.patch(`/api/question-papers/feedback/${id}`, body);
    },

    uploadLogo: (file) => {
        const fd = new FormData();
        fd.append('file', file);
        return api.post('/api/question-papers/logo', fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    // Deducts 1 credit + logs a PDF export. Call before generating the PDF.
    // checkExport: read-only "can the credit be paid?" BEFORE making the PDF; recordExport takes the credit AFTER it was produced.
    checkExport: (data = {}) => api.post('/api/question-papers/export/check', data),
    recordExport: (data = {}) => api.post('/api/question-papers/export', data),

    // Fetch a cross-origin question image (files.medhabi.bd / files.sohozkaj.com)
    // through the backend CORS proxy and return it as a data: URL, so html-to-image
    // can embed it into the exported PDF (those hosts send no CORS header).
    proxyImageDataUrl: async (url) => {
        const blob = await api.get('/api/question-papers/image-proxy', { params: { url }, responseType: 'blob' });
        return await new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = () => resolve(fr.result);
            fr.onerror = () => reject(new Error('image read failed'));
            fr.readAsDataURL(blob);
        });
    },
};

export default questionPaperService;
